document.addEventListener('DOMContentLoaded', function () {

  // Galerie : swipe sur mobile pour basculer entre les 2 images
  document.querySelectorAll('[data-gallery]').forEach(function (wrap) {
    var dots = wrap.querySelectorAll('[data-dot]');
    if (!dots.length) return;

    var startX = 0;
    var currentIndex = 0;

    function showImage(index) {
      currentIndex = index;
      if (index === 1) {
        wrap.classList.add('is-showing-2');
      } else {
        wrap.classList.remove('is-showing-2');
      }
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    wrap.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
    }, { passive: true });

    wrap.addEventListener('touchend', function (e) {
      var endX = e.changedTouches[0].clientX;
      var diff = startX - endX;
      if (Math.abs(diff) < 30) return;
      if (diff > 0 && currentIndex === 0) {
        showImage(1);
      } else if (diff < 0 && currentIndex === 1) {
        showImage(0);
      }
    }, { passive: true });
  });

  // Steppers de quantité
  document.querySelectorAll('[data-qty-minus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('[data-qty-input]');
      var val = parseInt(input.value, 10) || 1;
      if (val > 1) input.value = val - 1;
    });
  });

  document.querySelectorAll('[data-qty-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('[data-qty-input]');
      var val = parseInt(input.value, 10) || 1;
      input.value = val + 1;
    });
  });

  // Ajout au panier rapide en AJAX
  document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantId = btn.dataset.variantId;
      var row = btn.closest('.lna-card__row');
      var qtyInput = row ? row.querySelector('[data-qty-input]') : null;
      var quantity = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

      var originalText = btn.textContent;
      btn.textContent = 'Ajout en cours...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          btn.textContent = 'Ajouté !';
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          setTimeout(function () { btn.textContent = originalText; btn.disabled = false; }, 1500);
        })
        .catch(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        });
    });
  });
});